import { StaticWorkspace } from 'components/Workspaces/Static';
export default StaticWorkspace;
